import { useState } from 'react';

interface AlertProps {
  message?: string;
  type?: 'info' | 'success' | 'warning' | 'error';
  dismissible?: boolean;
}

const STYLES: Record<string, { bg: string; border: string; text: string; icon: string }> = {
  info: { bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-800', icon: 'ℹ' },
  success: { bg: 'bg-emerald-50', border: 'border-emerald-200', text: 'text-emerald-800', icon: '✓' },
  warning: { bg: 'bg-amber-50', border: 'border-amber-200', text: 'text-amber-800', icon: '⚠' },
  error: { bg: 'bg-red-50', border: 'border-red-200', text: 'text-red-800', icon: '✕' },
};

export function AlertBlock({ props }: { props: AlertProps }) {
  const [dismissed, setDismissed] = useState(false);
  if (!props.message || dismissed) return null;

  const s = STYLES[props.type ?? 'info'] ?? STYLES.info;

  return (
    <div className={`${s.bg} border ${s.border} ${s.text} rounded-lg px-4 py-3 flex items-start gap-3`} role="alert">
      <span className="text-lg leading-none mt-0.5">{s.icon}</span>
      {/* Content is admin-authored CMS content, not user input */}
      <div className="flex-1 text-sm prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: props.message }} />
      {props.dismissible && (
        <button onClick={() => setDismissed(true)} className="text-current opacity-50 hover:opacity-100 text-lg leading-none">×</button>
      )}
    </div>
  );
}
